$('body').on('click', '.filter-toggle', function(){
	var target = $('.filters-toggle-container');
  	if( typeof $(this).data('filter-target') ){
  		target = '.' + $(this).data('filter-target');
  	}
  	
  	if( $(target).hasClass('visible') ){
		$(this).trigger('filter-target-hide');
    }else{
      	$(this).trigger('filter-target-visible');
    }
});

$('body').on('filter-target-visible', '.filter-toggle', function(){
	var target = $('.filters-toggle-container');
  	if( typeof $(this).data('filter-target') ){
  		target = '.' + $(this).data('filter-target');
  	}	
    var target_height = $(target).children('div').outerHeight();
    $(target).css({height:target_height + 'px', opacity:1});  
	$(target).addClass('visible');
});

$('body').on('filter-target-hide', '.filter-toggle', function(){
	var target = $('.filters-toggle-container');
  	if( typeof $(this).data('filter-target') ){
  		target = '.' + $(this).data('filter-target');
  	}	
    $(target).css({height:0, opacity:0});
    $(target).removeClass('visible');
});

$('body').on('qty-increase', '*[name="quantity"]', function(){

  var value = parseInt($(this).val(), 10);
  if( typeof $(this).attr('max') !== 'undefined' ){
   var max_val = $(this).attr('max');
  }
  
  value = isNaN(value) ? 0: value;
  if( typeof max_val !== 'undefined' && value == max_val ){
  	return;
  }
  value++;
  $(this).val( value );

});

$('body').on('qty-decrease', '*[name="quantity"]', function(){

  var value = parseInt($(this).val(), 10);
  var min_val = 1;
  if( typeof $(this).attr('min') !== 'undefined' ){
  	min_val = $(this).attr('min');
  }
  value = isNaN(value) ? min_val : value;
  value--;
  
  value < min_val ? value = min_val : '';

  $(this).val( value );

});


$('body').on('click', '.value-button', function(){
  console.log( 'click' );
	var knoops_qty = $(this).closest('.knoops-qty');
  	if( $(this).hasClass('vb-decrease') ){
  		$(knoops_qty).find('*[name="quantity"]').trigger( 'qty-decrease' );     
    }else{
      
  		$(knoops_qty).find('*[name="quantity"]').trigger( 'qty-increase' ); 
    }
});


$('body').on('open-expandable', '.kai-toggler', function(){
  	var target = $(this).data('target');
  	var open_label = $(this).data('open');
  	var close_label = $(this).data('close');
  
	var target_height = $(target).find('.kai-expandable-inner').outerHeight();  
  	$(target).css({'height':target_height});
  	$(this).html(close_label);
  
});

$('body').on('close-expandable', '.kai-toggler', function(){
  	var target = $(this).data('target');
  	var open_label = $(this).data('open');
  	var close_label = $(this).data('close');
  
	var target_height = $(target).find('.kai-expandable-inner').outerHeight();  
  	$(target).css({'height':0});
  	$(this).html(open_label);
  
});

$('.kai-toggler').trigger('close-expandable');

$('body').on('click', '.kai-toggler', function(){

  	if( $(this).hasClass('closed') ){
    	$(this).trigger('open-expandable');
      	$(this).removeClass('closed');
    }else{
    	$(this).trigger('close-expandable');
      	$(this).addClass('closed');    	
    }
  
});

function filterPath(string) {
  return string
    .replace(/^\//, '')
    .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
    .replace(/\/$/, '');
}

var locationPath = filterPath(location.pathname);
$('a[href*="#"]').each(function () {
  var thisPath = filterPath(this.pathname) || locationPath;
  var hash = this.hash;
  if ($("#" + hash.replace(/#/, '')).length) {
    if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
      var $target = $(hash), target = this.hash;
      if (target) {
        $(this).click(function (event) {
          event.preventDefault();
          $('html, body').animate({scrollTop: $target.offset().top}, 1000, function () {
            location.hash = target; 
            $target.focus();
            if ($target.is(":focus")){ //checking if the target was focused
              return false;
            }else{
              $target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
              $target.focus(); //Setting focus
            };
          });       
        });
      }
    }
  }
});

$(window).load(function(){
  
  var $target = $(window.location.hash);
  
  if( typeof $($target)[0] === 'undefined' ){
  	return;
  }
  
  $('html, body').animate({scrollTop: $target.offset().top}, 1000, function () {
    
    $target.focus();
    if ($target.is(":focus")){ //checking if the target was focused
      return false;
    }else{
      $target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
      $target.focus(); //Setting focus
    };
  }); 
  
 
});

$('document').ready(function(){
  
if( typeof $.magnificPopup !== 'undefined') {

  $('body').on('click','.video-thumbnail', function(){
  		
    if( typeof $(this).data('url') === 'undefined'){
    	return false;
    }
    var contentforpopup = $(this).data('url'); console.log(contentforpopup);
    if( contentforpopup.indexOf( 'youtube.com/embed/' ) > 0 ){
    	contentforpopup = contentforpopup.replace('youtube.com/embed/', 'youtube.com/watch?v=');
    }
        $.magnificPopup.open(
          {
            'items':{
            'src': contentforpopup,
            'type': 'iframe'
            }
          });     
    
  });
  
}

});


$('body').on('click', '.js-toggle-submenu', function(){
  var parent = $(this).closest('.mobile-nav__item');
  var child = $(parent).find('.mobile-nav__dropdown')[0];
  
  if( $(this).hasClass('active') ){
    $(this).removeClass('active');
    $(child).removeClass('active');  	
  }else{
    $(this).addClass('active');
    $(child).addClass('active');
  }	
  
});

var step_process = {
  init: function(){
    $('.knoops-steps-container').each(function(){
    	step_process.checkActive( this );
    });
    $('body').on('click', '[data-steps-target]', function(){
      var target_step = $(this).data('steps-target');
      if( typeof $(this).data('steps-target') !== 'undefined' && typeof $(this).closest('.knoops-steps-container')[0] !== 'undefined' && typeof $(this).closest('.knoops-steps-container').find('.kaps-step[data-steps-target="'+$(this).data('steps-target')+'"]')[0] !== 'undefined' ){
      	$(this).closest('.knoops-steps-container').find('.kaps-step').removeClass('selected');
        $(this).closest('.knoops-steps-container').find('.kaps-step[data-steps-target="'+$(this).data('steps-target')+'"]').addClass( 'selected' );
        step_process.checkActive( $(this).closest('.knoops-steps-container') ); 
      }
    });
    $(window).on('resize', function(){
      $('.knoops-steps-container').each(function(){
          step_process.checkActive( this );
      });    	
    });
    $('body').on('multiVariantChange', function(){
      $('.knoops-steps-container').each(function(){
          step_process.checkActive( this );
      });    	
    });
  	var currLoc = window.location.hash.substr(1);
  	if( currLoc !== '' ){
  		/* Is there a [data-steps-target] with same currLoc ?*/
      $('[data-steps-target]').each(function(){
        console.log( $.trim($(this).text()) );
        if( $.trim( $(this).text().toLowerCase() ) === currLoc ){
        	$(this).trigger('click');
        } 
      });
    }
  },
  checkActive: function( stepContainer ){
  	var currKapsStep = $(stepContainer).find('.kaps-step.selected');
    if( typeof $(currKapsStep)[0] === 'undefined' ){
    	currKapsStep = $(stepContainer).find('.kaps-step').eq(0).addClass('selected');
    }
    $(stepContainer).find('.kaps-step').each(function(){
      if( typeof $(this).data('steps-target') !== 'undefined' ){
        $(stepContainer).find( $(this).data('steps-target') ).css({height:0,overflow:'hidden'});
      }
    });
    if( typeof $(currKapsStep).data('steps-target') !== 'undefined' && typeof $(stepContainer).find( $(currKapsStep).data('steps-target') )[0] !== 'undefined' && typeof $(stepContainer).find( $(currKapsStep).data('steps-target') ).find('.product-template__container')[0] !== 'undefined' ){
    	var potHeight = $(stepContainer).find( $(currKapsStep).data('steps-target') ).find('.product-template__container').outerHeight(); 
      	$(stepContainer).find( $(currKapsStep).data('steps-target') ).css({height: potHeight,overflow:'visible' });	
    }
  }

};

$(document).ready(function(){
	step_process.init();
});

$(window).load(function(){
    $('.knoops-steps-container').each(function(){
    	step_process.checkActive( this );
    });
});

$(document).ready(function(){
  $('body').on('change','input.add-product',function(){
    if( $(this).prop('checked') === true ){
      var $addData= {
        items:[
          { 'id': $(this).val(), 'quantity':1 }
        ]
      };
      
         jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js', 
          data: $addData,
          dataType: 'json',
          success: function() {
            window.location.href = '/cart';
          },
          error: function( e ){
            console.log( e );
          }
        });
      
      
    }
  });
  
  $('body').on('click','a[data-addgw]', function(){
  	
  	if( typeof $(this).closest('.gw-content')[0] !== 'undefined' && typeof $(this).closest('.gw-content').find('.gw-product-select')[0] !== 'undefined' ){
    	var gw_selected = $(this).closest('.gw-content').find('.gw-product-select').val();
        var $addData= {
          items:[
            { 'id': gw_selected, 'quantity':1 }
          ]
        };
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js', 
          data: $addData,
          dataType: 'json',
          success: function() {
            window.location.href = '/cart';
          },
          error: function( e ){
            console.log( e );
          }
        });      	
    }
  });
  
  function updateGWSelect(){
  	var gwItemID = $('.gw-item.selected').data('variant-id');
    if( typeof gwItemID === 'undefined' ){
    	return false;
    }
    var gwContentSelect = $('.gw-item.selected').closest('.gw-content').find('select.gw-product-select');
    $(gwContentSelect).find('option').each(function(){
      if( $(this).val() === gwItemID ){
      	$(this).prop('selected', true);
      }else{
      	$(this).prop('selected', false);
      }
    });
    $(gwContentSelect).val(gwItemID);
  }
  $('body').on('click','.gw-item',function(){
    if( !$(this).hasClass('selected') ){
    	$('.gw-item').removeClass('selected');
      	$(this).addClass('selected');
      	updateGWSelect();
    }
  });
  $('body').on('click','.gw-controller',function(){
  	var gwContainer = $(this).closest('.gw-container');
    if( $(gwContainer).hasClass('active') ){
    	$(gwContainer).removeClass('active');
    }else{
    	$(gwContainer).addClass('active');
    }
  });
  
  $('body').on('click','a[data-addgiftmessage]',function(){
  	var giftMessageContent = $(this).closest('.gift-message-content');
    var gm_textarea = $(giftMessageContent).find('#giftMessage');
    if( $( gm_textarea ).val().length > 0 ){
      var gm_data = document.createElement('div');
      gm_data.textContent = $( gm_textarea ).val(); /* Sanitized if using gm_data.innerHTML*/

      if( gm_data.innerHTML.trim() === '' ){
        return false;
      }
      
      var $addData= {
        items:[
          { 'id': $(this).data('product-id'), 'quantity':1, 'properties': {'Gift Message': gm_data.innerHTML } }
        ]
      };
      
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js', 
        data: $addData,
        dataType: 'json',
        success: function() {
          window.location.href = '/cart';
        },
        error: function( e ){
          console.log( e );
        }
      });
    } 
  });

  /* If gift message is present then check for submit events on the cart form */
  if ( $('body.template-cart').find('form[action="/cart"]').length > 0 && $('input[name="enable-giftmessage"]').length > 0 ){   
    $('form[action="/cart"]').submit( function(eve){
     
      if( $('input[name="enable-giftmessage"]').prop('checked') ){
        

        var giftMessageContent = $('.gift-message-content');
        var gm_textarea = $(giftMessageContent).find('#giftMessage');
         if( $(gm_textarea).val() && $( gm_textarea ).val().length > 0 ){ 
           eve.preventDefault();
            var prdID = $('a[data-addgiftmessage]')[0];
            var gm_data = document.createElement('div');
            gm_data.textContent = $( gm_textarea ).val(); /* Sanitized if using gm_data.innerHTML*/           
            var $addData = {
              items: [{
                id: $(prdID).data('product-id'), 
                quantity: 1, 
                properties: { "Gift Message": gm_data.innerHTML }
              }]
            };
       
            $.ajax({
              type: 'POST',
              url: '/cart/add.js', 
              data: $addData,
              dataType: 'json',
              success: function() {
               window.location.href = '/checkout';
              },
              error: function( e ){
                console.log( e );
                window.location.href = '/checkout';
              }
            });          
         }
          
      }
    });
  }
  
  
  function is_gift_message(){
    if( $('#enable-giftmessage').prop('checked') === true ){
      $('.gift-message-content').addClass('show');
    }else{
      $('.gift-message-content').removeClass('show');	
    }
  }
  $('body').on('change','#enable-giftmessage',function(){ is_gift_message(); });
  is_gift_message();
});

$(document).ready(function(){
  function update_values(){
    $('.contact-form .contact-form-body').each(function(){
    	var contact_form = $(this).closest('.contact-form');
      	var subject_line = $(contact_form).find('select.subject').val();
      	var contact_form_content = $(contact_form).find('.contact-form-body').val();
        $(contact_form).find('textarea.contact-form-updated-content').val( 'Subject: '+subject_line+'\n\n'+contact_form_content );
    });
  }
  update_values();
  $('.contact-form textarea.contact-form-body,.contact-form select.subject').change(function(){
  	update_values();	
  });
});

$(document).ready(function(){
  $('.knoops-text-highlight').find('h1,h2,h3,h4,h5,h6,p').each(function(){
    var textContent = $(this).text();
  	$(this).html('<span>'+textContent+'</span>');
  });
});



$(document).ready(function(){
  
  function triggerSection( $section_target ){
    if( $('.sub-sections').find('.sub-section.active').data('k-section') === $($section_target).data('k-section') ){
      return false;
    }
  	$('.sub-sections').find('.sub-section').removeClass('active');
    $($section_target).addClass('active');
  }
  
  function triggerDropAreaActive( $target ){
    
    $('.knoops-dropdown-container').addClass('active');
    if( typeof $('.knoops-drop-area[data-menu-area="'+$target+'"]')[0] !== 'undefined' ){
    	$('.knoops-drop-area').removeClass('active');
	    $('.knoops-drop-area[data-menu-area="'+$target+'"]').addClass('active');
      	var $section_target = $('.knoops-drop-area[data-menu-area="'+$target+'"]').find('.sub-sections').find('[data-k-section="default"]');
      	if( typeof $($section_target)[0] !== 'undefined' ){
        	triggerSection( $section_target );
        }
    }  
  }

  function removeAllActive(){
  	$('.knoops-dropdown-container').removeClass('active');
    $('.knoops-ma-area').removeClass('active');
    $('.knoops-drop-area').removeClass('active');
  }
  
  function removeSubmenus(){
  	$('.sub-menus').removeClass('active');
    $('.submenu').removeClass('active');
    $('.mobile-sub-menu').removeClass('active');
  }
  
  function activateSubmenus($target){
  	var $subMenusContainer = $($target).closest('.sub-menus');    
    $($subMenusContainer).addClass('active');
    $($target).addClass('active');
  }  
  
  
  
  $('.knoops-ma-area').mouseenter(function(){
  	$('.knoops-ma-area').removeClass('active');
    $(this).addClass('active');
    var $target = $(this).data('menu-area');
	triggerDropAreaActive( $target );    
  });
  
  $('.ll-link').mouseenter( function(){
  	var $dropArea = $(this).closest('.knoops-drop-area');
    var k_section = 'default';
    if( typeof $(this).data('subsection-link') !== 'undefined' &&  typeof $( $dropArea ).find('[data-k-section="'+$(this).data('subsection-link')+'"]')[0] !== 'undefined' ){
    	k_section = $( $dropArea ).find('[data-k-section="'+$(this).data('subsection-link')+'"]').data('k-section');
    }
    if( typeof $( $dropArea ).find('[data-k-section="'+k_section+'"]')[0] !== 'undefined' ){
      	
    	triggerSection( $( $dropArea ).find('[data-k-section="'+k_section+'"]') );
    }
    if( $( this ).hasClass('tp-level') ){
      
      if( $( this ).hasClass('has-children') && typeof $(this).data('link-name') !== 'undefined' && typeof $($dropArea).find('.submenu[data-parent-link="'+$(this).data('link-name')+'"]')[0] !== 'undefined' ){
      	removeSubmenus();
        activateSubmenus( $($dropArea).find('.submenu[data-parent-link="'+$(this).data('link-name')+'"]') );
        $(this).find('.mobile-sub-menu').addClass('active'); 
      }else{
      	removeSubmenus();
      }
      
    }
  });
  
  $('.knoops-main-navigation').mouseleave(function(){
  	removeAllActive();
  });


  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  window.addEventListener("scroll", function(){ 
     var st = window.pageYOffset || document.documentElement.scrollTop; 
     if (st > lastScrollTop) {
       $(window).data('scrollDirection', 'down');
     } else if (st < lastScrollTop) {
        // upscroll code
       $(window).data('scrollDirection', 'up');
     } 
     lastScrollTop = st <= 0 ? 0 : st; 
  }, false); 
  

  
  function applyFixedNav(){
  	
    var annPadding = $('.knoops-navigation .announcement-bar').outerHeight();
    var shPadding = $('.knoops-navigation .site-header').outerHeight();
    var kmnPadding = $('.knoops-navigation .knoops-main-navigation').outerHeight();

    var padding = annPadding + shPadding + kmnPadding;
    
    $('body').css({'padding-top': padding + 'px'});
    $('.knoops-navigation').css({'position': 'fixed', 'top': 0 });
  }
  function hideAnnouncementBar(){
    var padding = $('.knoops-navigation').find('.announcement-bar').outerHeight();
     var st = window.pageYOffset || document.documentElement.scrollTop;
    if( st > padding ){
      if( typeof $(window).data('scrollDirection') !== 'undefined' ){
        if( $(window).data('scrollDirection') === 'down' ){
          //$('.knoops-navigation').find('.announcement-bar').hide();
          $('.knoops-navigation').find('.announcement-bar').addClass('hide-announcement');
          $('.knoops-navigation').find('.announcement-bar').css('transition', 'margin-top 0.5s ease');
          $('.knoops-navigation').find('.announcement-bar').css('margin-top', (padding + 2) * -1 );
        }else{
          //$('.knoops-navigation').find('.announcement-bar').show();
          $('.knoops-navigation').find('.announcement-bar').removeClass('hide-announcement');
          $('.knoops-navigation').find('.announcement-bar').css('margin-top', 0 );
        }
        applyFixedNav();
      }
    }else{
      $('.knoops-navigation').find('.announcement-bar').show();
    }
  }

  window.addEventListener("scroll", function(){
    hideAnnouncementBar();
  });  
  applyFixedNav();
  $(window).resize(applyFixedNav);
  
  
});


$(document).ready(function(){
  $('body').on('click', '.ruk_rating_snippet.clickable', function(){
    if( typeof $('[data-target=".kai-expandable-reviews"]')[0] !== 'undefined' ){
    	/* Scroll position of the nav */
      	var knoopsNavHeight = $('.knoops-navigation').height();
      	var offsetReviews = $('[data-target=".kai-expandable-reviews"]').offset();
      	$('[data-target=".kai-expandable-reviews"]').trigger('click');
      	$("HTML, BODY").animate({
          scrollTop: offsetReviews.top - knoopsNavHeight - 20
        },500);
    }
  });
});

/* Formspark */
$(document).ready(function(){
  $('[data-monitor]').each(function(){
  	var currForm = $(this).closest('form');
    var dm = $(this);
    var riName = $(this).data('monitor');
    var relatedInput = $(currForm).find('[name="'+riName+'"]');
    $(relatedInput).on('change', function(){
      $(dm).val( $(this).val() );
    });                                    
  });
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if ( typeof urlParams.get('productid') !== 'undefined' ){
  	$('option[data-product-id="'+urlParams.get('productid')+'"]').prop('selected', 'selected');
  }
});

function selectCorrectFormspark(CFS){
  if( typeof $('.has-form-spark-selector-label[data-form-spark-label="'+CFS+'"]')[0] !== 'undefined' ){
  	$('.has-form-spark-selector-label').removeClass('active');
    $('.has-form-spark-selector-label[data-form-spark-label="'+CFS+'"]').addClass('active');
  }
}      	


$(document).ready(function(){
	if( typeof $('.formspark-selector')[0] !== 'undefined' && typeof $('[name="formspark-selector"]')[0] !== 'undefined' && $('[name="formspark-selector"]') !== '' ){
      var currFormSpark = $('[name="formspark-selector"]');
      
      selectCorrectFormspark( $(currFormSpark).val() ); 
      
      $(currFormSpark).change( function() { 
        selectCorrectFormspark( $(this).val() ); 
      });
      
      
      
    }
});

$( document ).ready(function(){
  $( 'body' ).on('click','.submit-collection-tag-filters',function(){
  	var tag_filter_container = jQuery(this).closest(".filters-toolbar__item-child");
    if (typeof jQuery(tag_filter_container)[0] !== 'undefined' ){ 
   		var current_filter_list = [];
      	var all_tag_filters = jQuery(tag_filter_container).find('.tag-collection-group input'); 
      	jQuery(all_tag_filters).each( function(){
          if( jQuery(this).is(":checked") ){
      		current_filter_list.push( jQuery(this).val() );
          }
      	});
        var destination_list = '';
      	if( current_filter_list.length > 0 ){
          	var destination_list = current_filter_list.join('+');
      	}
        var destination = jQuery(this).data('submit-url');
      	window.location = destination + '/' + destination_list;
    }
  });
});

$(document).ready(function(){
  $('body').on('click','.hero-element-clickable',function(){
    if( typeof $(this).find('a')[0] !== 'undefined' && $(this).find('a').attr('href') !== '#' ){
      window.location = $(this).find('a').attr('href');
    }
  });
});


$( document ).ready(function(){
  $('[data-typeform-external]').each(function(){
    /* LOAD TYPEFORM */
    var tf_part = 'https://form.typeform.com/to/';
    var destination_url = tf_part +$(this).data('typeform-external');
    console.log(destination_url);
    window.open(destination_url, '_blank');
  });

});

$( document ).ready( function(){
$('.hero-text-content .mega-subtitle').each(function(){
    var html_text = $(this).html();
    if( html_text.match(/(<!--\s*read-more.*-->)/gmi) ){
      var beforeArray = [];
      var afterArray = [];
      var arraySwitch = false;
      var css_classes = [];
      var html_array = html_text.split(/(<!--\s*read-more.*-->)/gmi);
      for ( key in html_array ){
        if ( html_array[key].match(/(<!--\s*read-more.*-->)/gmi) ){
          arraySwitch = true;
          css_classes.push( html_array[key].replace(/(<!--|-->|\s)/gmi,'') );
          continue;
        }
        if( arraySwitch == true ){
          afterArray.push(html_array[key]);
        }else{
          beforeArray.push(html_array[key]);
        }
      }
      var beforeDiv = document.createElement('div');
      var afterDiv = document.createElement('div');
      var fullContainer = document.createElement('div');
      beforeDiv.className = 'rm-before';
      afterDiv.className = 'rm-after';
      fullContainer.className = 'rm-container';
      beforeDiv.innerHTML = beforeArray.join('');
      afterDiv.innerHTML = html_text;
      if ( beforeArray.length > 0 ){
        fullContainer.appendChild(beforeDiv);
      }
      if ( afterArray.length > 0 ){
      fullContainer.appendChild(afterDiv);
      } 
      if( beforeArray.length > 0 && afterArray.length > 0 ){
        var readMore = document.createElement('div');
        readMore.className = 'rm-read-more-controller';
        readMore.innerHTML = '<span class="rm-read-more">Read More</span><span class="rm-read-less">Read Less</span>';
        fullContainer.appendChild(readMore);
      }
      fullContainer.classList.add(...css_classes);
      $(this).html(fullContainer);
      
    }
    $(this).closest('.hero-collection-para').addClass('init');
  });
  $('body').on('click', '.rm-read-more-controller', function(){
    if( typeof $(this).closest('.rm-container')[0] !== 'undefined' && $(this).closest('.rm-container').hasClass('open') ){
      $(this).closest('.rm-container').removeClass('open');
    }else{
      $(this).closest('.rm-container').addClass('open');
    }
  } );
});

$('body').on('click', '.product-card__image-with-placeholder-wrapper', function() {
  var firstLink = $(this).closest('.product-card').find('a')[0];
  window.location = firstLink.href;
});